'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../../../languageHandler');

var _MatrixClientPeg = require('../../../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _ = require('../../../../..');

var _2 = _interopRequireDefault(_);

var _AccessibleButton = require('../../../elements/AccessibleButton');

var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);

var _Modal = require('../../../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdvancedRoomSettingsTab = function (_React$Component) {
    (0, _inherits3.default)(AdvancedRoomSettingsTab, _React$Component);

    function AdvancedRoomSettingsTab() {
        (0, _classCallCheck3.default)(this, AdvancedRoomSettingsTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AdvancedRoomSettingsTab.__proto__ || (0, _getPrototypeOf2.default)(AdvancedRoomSettingsTab)).call(this));

        _this._upgradeRoom = function (e) {
            var RoomUpgradeDialog = _2.default.getComponent('dialogs.RoomUpgradeDialog');
            var room = _MatrixClientPeg2.default.get().getRoom(_this.props.roomId);
            _Modal2.default.createTrackedDialog('Upgrade Room Version', '', RoomUpgradeDialog, { room: room });
        };

        _this._openDevtools = function (e) {
            var DevtoolsDialog = _2.default.getComponent('dialogs.DevtoolsDialog');
            _Modal2.default.createDialog(DevtoolsDialog, { roomId: _this.props.roomId });
        };

        _this.state = {
            // This is eventually set to the value of room.getRecommendedVersion()
            upgradeRecommendation: null
        };
        return _this;
    }

    (0, _createClass3.default)(AdvancedRoomSettingsTab, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            // we handle lack of this object gracefully later, so don't worry about it failing here.
            _MatrixClientPeg2.default.get().getRoom(this.props.roomId).getRecommendedVersion().then(function (v) {
                _this2.setState({ upgradeRecommendation: v });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var client = _MatrixClientPeg2.default.get();
            var room = client.getRoom(this.props.roomId);

            var unfederatableSection = void 0;
            var createEvent = room.currentState.getStateEvents('m.room.create', '');
            if (createEvent && createEvent.getContent()['m.federate'] === false) {
                unfederatableSection = _react2.default.createElement(
                    'div',
                    null,
                    (0, _languageHandler._t)('This room is not accessible by remote Matrix servers')
                );
            }

            var roomUpgradeButton = void 0;
            if (this.state.upgradeRecommendation && this.state.upgradeRecommendation.needsUpgrade) {
                roomUpgradeButton = _react2.default.createElement(
                    _AccessibleButton2.default,
                    { onClick: this._upgradeRoom, kind: 'primary' },
                    (0, _languageHandler._t)("Upgrade room to version %(ver)s", { ver: this.state.upgradeRecommendation.version })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'mx_SettingsTab' },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_heading' },
                    (0, _languageHandler._t)("Advanced")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_section mx_SettingsTab_subsectionText' },
                    _react2.default.createElement(
                        'span',
                        { className: 'mx_SettingsTab_subheading' },
                        (0, _languageHandler._t)("Room information")
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            (0, _languageHandler._t)("Internal room ID:")
                        ),
                        '\xA0',
                        this.props.roomId
                    ),
                    unfederatableSection
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_section mx_SettingsTab_subsectionText' },
                    _react2.default.createElement(
                        'span',
                        { className: 'mx_SettingsTab_subheading' },
                        (0, _languageHandler._t)("Room version")
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            (0, _languageHandler._t)("Room version:")
                        ),
                        '\xA0',
                        room.getVersion()
                    ),
                    roomUpgradeButton
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_section mx_SettingsTab_subsectionText' },
                    _react2.default.createElement(
                        'span',
                        { className: 'mx_SettingsTab_subheading' },
                        (0, _languageHandler._t)("Developer options")
                    ),
                    _react2.default.createElement(
                        _AccessibleButton2.default,
                        { onClick: this._openDevtools, kind: 'primary' },
                        (0, _languageHandler._t)("Open Devtools")
                    )
                )
            );
        }
    }]);
    return AdvancedRoomSettingsTab;
}(_react2.default.Component); /*
                              Copyright 2019 New Vector Ltd
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

AdvancedRoomSettingsTab.propTypes = {
    roomId: _propTypes2.default.string.isRequired
};
exports.default = AdvancedRoomSettingsTab;
module.exports = exports['default'];
//# sourceMappingURL=AdvancedRoomSettingsTab.js.map